import React from 'react'
import Dropdown from '../Dropdown'

const BranchList = ({ dropdownItems = [] }) => {
	return (
		<Dropdown
			items={dropdownItems}
			visible
			canSearch
		/>
	)
}

export default BranchList
